































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as data from "../_store/data.module";
import * as user from "../_store/user.module";
import { bus } from "../main";

@Component
export default class Questionario extends Vue {
  @Prop() info!: any;
  @Prop() idRichiesta!: number;
  @Prop() activityType!: string;
  @Prop() tipoQuestionario!: string;

  private domande: any;
  private gruppi: any;
  private listaGruppi: any;
  private listaRisposte: any;
  private listaDomande: any;
  private note: string;

  private noteRules: [boolean | string];
  private multipleResponse: any;

  private rules: any;

  constructor() {
    super();
    this.domande = [];
    this.gruppi = [];
    this.listaGruppi = [];
    this.listaRisposte = [];
    this.listaDomande = [];
    this.note = "";

    this.noteRules = [true];
    this.multipleResponse = [];
    this.rules = {
      length: (len:any) => (v: any) => (v || '').length < len || `Le Note non possono superare i ${len} caratteri`
    }
  }

  close() {
    bus.$emit("closeQuestionarioDialog");
  }

  validazioneNote() {
    var valid: boolean = false;
    if (this.note === "" || this.note === null) {
      this.noteRules = [true];
    } else {
      if (this.note !== "" || this.note !== null) {
        valid = /^[0-9a-zA-Zìèéùòà!?;:,.\\'\x20]{2,250}$/.test(this.note);
      }
      if (valid) {
        this.noteRules = [true];
      } else {
        this.noteRules = [
          "Le Note non possono avere più di 250 caratteri e non devono contenere caratteri speciali"
        ];
      }
    }
  }

  aggiungiRisposta(value: any, idDomanda: number) {
    let alreadyExist: boolean = false;
    let indiceRisposta: any;
    let valoreRisposta: number = 0;
    if (typeof value === "string") {
      valoreRisposta = parseInt(value);
    } else {
      valoreRisposta = value;
    }
    alreadyExist = this.listaRisposte.some(
      (risposta: any) => risposta["idDomanda"] === idDomanda
    );
    if (alreadyExist) {
      indiceRisposta = this.listaRisposte.findIndex(
        (risposta: any) => risposta.idDomanda === idDomanda
      );
      this.listaRisposte[indiceRisposta].risposta = valoreRisposta;
    } else {
      this.listaRisposte.push({
        idDomanda: idDomanda,
        risposta: valoreRisposta,
        rispostaNota: null
      });
    }
  }

  aggiungiRispostaNota(value: any, idDomanda: number) {
    let alreadyExist: boolean = false;
    let indiceRisposta: any;
    alreadyExist = this.listaRisposte.some(
      (risposta: any) => risposta["idDomanda"] === idDomanda
    );
    if (alreadyExist) {
      indiceRisposta = this.listaRisposte.findIndex(
        (risposta: any) => risposta.idDomanda === idDomanda
      );
      this.listaRisposte[indiceRisposta].rispostaNota = String(value);
    } else {
      this.listaRisposte.push({
        idDomanda: idDomanda,
        risposta: 0,
        rispostaNota: String(value)
      });
    }
  }

  async executeTest() {
    this.validazioneNote();
  }

  save() {
    var payload = {
      idRichiesta: this.idRichiesta,
      activityType: this.activityType,
      tipoQuestionario: this.tipoQuestionario,
      listaRisposte: this.listaRisposte,
      note: this.note
    };
    if (this.listaRisposte.length === this.listaDomande.length) {
      this.executeTest().then(() => {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
          user
            .dispatchCreateQuestionario(this["$store"], payload)
            .then(() => {
              bus.$emit(
                "successfullOperation",
                "Questionario salvato con successo"
              );
              this.close();
              bus.$emit("loadAssegnazioni");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              }
            });
        }
      });
    } else {
      bus.$emit("errorOperation", "Una o più risposte mancanti");
    }
  }

  created() {
    var payload = {
      idRichiesta: this.idRichiesta,
      activityType: this.activityType,
      tipoQuestionario: this.tipoQuestionario
    };
    var listaDomandeGruppo: any[] = [];
    data.dispatchDomandeQuestionario(this["$store"], payload).then(result => {
      this.listaDomande = result;
      result.forEach((element: any) => {
        if (!this.gruppi.includes(element.idGruppoDomanda)) {
          this.gruppi.push(element.idGruppoDomanda);
        }
      });
      this.gruppi.forEach((gruppo: any) => {
        var gruppoElem = {
          idGruppo: 0,
          descrizioneGruppo: "",
          domandeGruppo: []
        };
        gruppoElem.idGruppo = gruppo;
        result.forEach((domanda: any) => {
          if (domanda.idGruppoDomanda === gruppoElem.idGruppo) {
            gruppoElem.descrizioneGruppo = domanda.descrizioneGruppoDomanda;
            gruppoElem.domandeGruppo.push({
              //@ts-ignore
              idDomanda: domanda.idDomanda,
              //@ts-ignore
              descrizioneDomanda: domanda.descrizioneDomanda,
              //@ts-ignore
              rangeRisposta: domanda.rangeRisposta,
              //@ts-ignore
              idTipoDomanda: domanda.idTipoDomanda,
              //@ts-ignore
              opzione1: domanda.opzione1,
              //@ts-ignore
              opzione2: domanda.opzione2,
              //@ts-ignore
              opzione3: domanda.opzione3,
              //@ts-ignore
              opzione4: domanda.opzione4,
              //@ts-ignore
              opzione5: domanda.opzione5,
              //@ts-ignore
              opzione6: domanda.opzione6,
              //@ts-ignore
              opzione7: domanda.opzione7,
              //@ts-ignore
              opzione8: domanda.opzione8,
              //@ts-ignore
              opzione9: domanda.opzione9,
              //@ts-ignore
              opzione10: domanda.opzione10,
              //@ts-ignore
              opzione11: domanda.opzione11,
              //@ts-ignore
              opzione12: domanda.opzione12,
              //@ts-ignore
              opzione13: domanda.opzione13,
              //@ts-ignore
              testoNota: domanda.testoNota,
              //@ts-ignore
              notaObbligatoria: domanda.notaObbligatoria,
              //@ts-ignore
              rispostaMultipla: domanda.rispostaMultipla
            });
          }
        });
        listaDomandeGruppo.push(gruppoElem);
      });
      this.domande = listaDomandeGruppo;
    });
  }
}
